<template>
  <div>
    <outreach-list
      v-if="outreachs.length || (emptyTitle.length + emptySubtitle.length)"
      :outreachs="outreachs"
      :outreachs-count="outreachsCount"
      :page-size="pageSize"
      :title="title"
      :events-percentage="eventsPercentage"
      :empty-title="emptyTitle"
      :empty-subtitle="emptySubtitle"
      :loading="loading"
      :show-sender="isAdminMode"
      :unique-events="uniqueEvents"
      @page-change="pageChange"
    />
  </div>
</template>
<script>
import OutreachList from './OutreachList';

export default {
  components: {
    OutreachList,
  },
  props: {
    // Outreachs filter to pass to query params
    filter: {
      type: Object,
      default: () => ({}),
      required: false,
    },
    pageSize: {
      type: Number,
      default: 12,
    },
    managerScope: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    emptyTitle: {
      type: String,
      default: 'No reports yet',
    },
    emptySubtitle: {
      type: String,
      default: 'Sales Associate must start creating edits to start receiving reports',
    },
    eventsPercentage: {
      type: Boolean,
      default: true,
    },
    // Show unique events instead of total events (clicks, opens)
    uniqueEvents: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    user() {
      return this.stylist || this.$store.state.account.user;
    },
    outreachsCount() {
      return this.$store.state.outreachs.count;
    },
    outreachs() {
      return this.$store.state.outreachs.items.slice();
    },
    loading() {
      return this.$store.state.outreachs.itemsLoading;
    },
    isAdminMode() {
      return this.$store.state.account.isAdminMode;
    },
    page() {
      return this.$store.state.outreachs.page;
    },
  },
  watch: {
    // original checkin:  86895c6b9
    filter: {
      deep: true,
      handler(newFilter, oldFilter) { // example newFilter/oldFilter:  {"period":"ytd"}
        if (newFilter?.period !== oldFilter?.period) {
          this.fetch();
        }
      },
    },
  },
  mounted() {
    this.fetch();
  },
  methods: {
    fetch(paginationParams = { page_size: this.pageSize, page: this.page }) {
      const scopeFilter = { scope: this.managerScope ? 'manager' : 'stylist' };
      this.$store.dispatch('outreachs/fetchAll', {
        onlysent: true,
        ...this.filter,
        ...paginationParams,
        with_appointments: true,
        ...scopeFilter,
      });
    },
    pageChange(params) {
      this.fetch(params);
    },
  },
};
</script>
<style lang="scss"
  scoped>
</style>
